import { EDA } from "motw_core/Dreams/EDreamAttribute";
import * as React from "react";
import { Dreams } from "source/app/presentation/MainPanel/Dreams/Dreams";
import { ExcludeAttributesLink } from "source/app/presentation/MainPanel/Dreams/Exclusion/ExcludeAttributesLink";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export function ExclusionLinks({ dreams }: { dreams: Dreams }) {
    return (
        <div
            style={{
                padding: `10px`,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                marginTop: "6px",
            }}
        >
            <ExcludeAttributesLink dreams={dreams} attribute={EDA.problem} />
            <ExcludeAttributesLink dreams={dreams} attribute={EDA.decision} />
        </div>
    );
}

export const GetExclusionLinkStyleClass = (isActive: boolean) => {
    const color = isActive ? `dimgray` : `white`;

    return StyleClassAuto({
        color,
        background: `rgba(0, 0, 0, 0.15)`,
        borderRadius: `4px`,
        padding: `9px`,
        margin: `3px`,
    });
};
